module.exports = __webpack_public_path__ + "img/customisation.e9f0ba8e.svg";